
// import store from './store/index'
import Vue from 'vue'
import config from './config'
import axios from 'axios'
import router from './router'
import { Toast } from 'vant';
let wxData=config.wxData;
Vue.use(Toast);

axios.defaults.baseURL = config.API.BaseURL
axios.defaults.timeout = 5000

// 请求 拦截器
axios.interceptors.request.use(function (cfg) {
  let accessToken = localStorage.getItem(wxData.wechatid+'Token');
  let d = cfg.data
  if (!d) {
    if (!cfg.params) {
      cfg.params = {}
    }
    d = cfg.params
  }
  if(accessToken) {
    cfg.headers.Authorization = 'Bearer ' + accessToken
  }
  return cfg
}, function (error) {
  return Promise.reject(error)
})
// 添加响应拦截器
axios.interceptors.response.use(
  function (response) {
    // 接口正常返回，但是数据异常情况处理

    if (response.data && (response.data.status === 0||response.data.StatusCode===200)) 
    {
      return response.data
    } else {      
      Toast(response.data.message)
      if(response.data.status === 10050){
        router.replace({path: 'login.html'})
      }
      return Promise.reject(response.data)
    }
  },
  function (error) {
    // 本地调试errro构造函数的name值是Cancel线上是i，具体原因带排查
    if(error.constructor.name == 'Cancel' || error.constructor.name == 'i') {
      Toast('当前操作过于频繁,请稍后重试')
      // 请求错误时做些事
    } else {
      let errMsg = error.response.data;
      Toast(errMsg.message ? errMsg.message :'当前网络不稳定,请稍后重试');
    }
    // 请求错误时做些事
    return Promise.reject(error)
  }
)

export default axios
